@import '../../../global/scss/dropdown/mixins';

go-select {
  @include dropdown-item-vars;
  --dropdown-width: 100%;

  .combo {
    width: 100%;
    position: relative;
  }
  .control-icon {
    z-index: 1;
  }
  .control {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .arrow {
      height: 1.5em;
      @include transition(transform);
      &.open {
        transform: rotate(180deg);
      }
    }
  }

  go-dropdown {
    max-height: 20rem;
    overflow: auto;
    z-index: 9;
  }

  .combo-option {
    @include dropdown-item;

    &[aria-selected] {
      @include item-selected-state;
    }
  }

  &[disabled] {
    .combo-option {
      @include item-disabled-state;
    }
  }
}
